import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import languageEN from './assets/locales/en/translation.json'
// import languageAR from './assets/locales/ar/translation.json'
import Backend from 'i18next-http-backend';

// import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

// Determine initial language from persisted Redux store if available
let initialLng = 'en';
try {
  if (typeof window !== 'undefined' && window.localStorage) {
    const persisted = localStorage.getItem('persist:root');
    if (persisted) {
      const root = JSON.parse(persisted);
      if (root && root.user) {
        const userState = JSON.parse(root.user);
        if (userState && userState.locale) {
          initialLng = userState.locale;
        }
      }
    }
  }
} catch {}

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
//   .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: initialLng,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'fr'],
  ns: ['common', 'performance', 'timeoff', 'leaves', 'requests', 'employees', 'projects', 'organizations', 'payroll', 'attendance', 'tournament', 'billing', 'marketing',
    // UI-only demo previews (views/Previews/PayrollControls) — gated at runtime by DemoPreviews; small files.
    'previewCommon', 'previewRuns', 'previewDialogs', 'previewOutputs', 'previewSettings', 'previewInputs'],
    defaultNS: 'common',
  // Keep legacy keys available without loading the legacy namespace by default
  // We intentionally exclude 'translation' from ns to encourage migration,
  // but list it here so unresolved keys still resolve during the transition.
  fallbackNS: ['common', 'translation', 'tournament', 'marketing'],
  // Treat keys literally: translation files store flat keys (e.g. "Time & Attendance", "errorBoundary.title")
  // so we disable BOTH separators. A non-false value like ' ' caused t('Time & Attendance') to split into
  // a nested lookup path and fall back to the English key, which silently broke Arabic/French rendering.
  keySeparator: false,
  nsSeparator: ':',
    // resources: {
    //     en: languageEN,
    //     ar: languageAR
    // },
    backend: {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    // backend: backendOptions,
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;

// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";

// const resources = {
//   en: {
//     translation: {
//       "Login": "Login",
//       "Enter Your Username": "Enter Your Username",
//       "Enter Your Password": "Enter Your Password",
//       "Logout": "Logout",
//       "ToDo List": "ToDo List",
//       "Enter a title": "Enter a title",
//       "Add": "Add",
//       "Edit": "Edit",
//       "Please enter a username":"Please enter a username",
//       "Please enter a password":"Please enter a password",
//       "Please enter both username and password":"Please enter both username and password",
//       "User logged out successfully":"User logged out successfully",
//       "User logged in successfully":"User logged in successfully",
//       "No Data To Display":"No Data To Display",
//       "English":"English",
//       "French":"French"
//     },
//   },
//   fr: {
//     translation: {
//       "Login": "Se Connecter",
//       "Enter Your Username": "Saisissez votre nom d'utilisateur",
//       "Enter Your Password": "Saisissez votre mot de passe",
//       "Logout": "Se Déconnecter",
//       "ToDo List": "Liste de choses à faire",
//       "Enter a title": "Saisissez un titre",
//       "Add": "Ajouter",
//       "Edit": "Modifier",
//       "Please enter a username":"S'il vous plait saisissez un nom d'utilisateur",
//       "Please enter a password":"S'il vous plait saisissez un mot de passe",
//       "Please enter both username and password":"S'il vous plait saisissez les deux: nom d'utilisateur et mot de passe",
//       "User logged out successfully":"Utilisateur s'est déconnecté",
//       "User logged in successfully":"Utilisateur s'est connecté",
//       "No Data To Display":"Pas de données",
//       "Change Language":"Changer de langues",
//       "English":"Anglais",
//       "French":"Français"
//     },
//   },
// };
// i18n.use(initReactI18next).init({
//   resources,
//   lng: "eng", //language to use
//   interpolation: {
//     escapeValue: false,
//   },
// });
// export default i18n;